import React, {memo} from 'react';

import {Contact} from '../../../types';

import {Divider, IconButton, List} from 'react-native-paper';
import {
  NavigationProp,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {ChatParams, ChatStackParams} from '../../../types/nav';
import {useAppDispatch} from '../../../store/hooks';
import {setToastText} from '../../../store/slices/ui';
import {Clipboard} from 'react-native';
import {domain} from '../../../api';

export interface ContactItemProps {
  i: Contact;
  width: number;
}

const ContactItem = (contactItemProps: ContactItemProps) => {
  const {i, width} = contactItemProps;
  const route = useRoute();
  const params = route.params as ChatParams;
  const navigation = useNavigation<NavigationProp<ChatStackParams>>();
  const isOpen = params?.chatId === i.id;
  const contact = i;
  const title = i.name || i.id;
  const icon = isOpen ? 'chat' : 'chat-outline';
  const dispatch = useAppDispatch();
  const onPressContact = () => {
    navigation.navigate({
      name: 'Chat',
      params: {
        chatId: contact.id,
        name: contact.name,
        parentFolderId: contact.folderId,
        mnemonic: contact.mnemonic,
      },
    });
  };

  const onPressShare = () => {
    const linktoChat =
      domain +
      'webapp/contact/chat/' +
      contact.id +
      '?name=' +
      encodeURIComponent(contact.name) +
      '&mnemonic=' +
      encodeURIComponent(contact.mnemonic);
    Clipboard.setString(linktoChat);
    dispatch(
      setToastText(
        'Link to conversation has been copied: \n' + linktoChat,
      ),
    );
  };

  const children = isOpen ? <></> : null;
  return (
    <>
      <List.Item
        style={{width}}
        title={title}
        left={props => (
          <IconButton onPress={onPressContact} icon={icon} />
        )}
        onPress={onPressContact}
        right={props => (
          <>
            <IconButton icon="share" onPress={onPressShare} />
          </>
        )}
      />
      <Divider />
    </>
  );
};
export default memo(ContactItem);
